import React, { Fragment } from "react";
import { Menu, Transition } from "@headlessui/react";
import { ReactComponent as DownArrowIcon } from "assets/common/dropdown/downArrowIcon.svg";
import { cls } from "shared/lib/util/classnames";

interface Props {
  label: string;
  menuList: { id: string; name: string }[];
  selectMenu: string;
  onClick: (id: string) => void;
}

export function CaseDropdown({ label, menuList, selectMenu, onClick }: Props) {
  return (
    <Menu as="div" className="relative inline-block w-full text-left">
      {(open) => (
        <>
          <div>
            <Menu.Button
              className={cls(
                "inline-flex h-[56px] w-full items-center justify-between gap-[8px] rounded-[4px] border-[1px] border-[#dadada] bg-[#fafafa] px-[24px] py-[16px] text-M3 text-[#c6c6c6] shadow-sm focus:outline-none focus:ring-white",
                selectMenu ? "!text-[#494949]" : "",
              )}
            >
              {selectMenu ? selectMenu : label}
              <DownArrowIcon
                className={cls(
                  selectMenu &&
                    "[&>*:nth-child(1)]:[&>*:nth-child(2)]:fill-[#494949]",
                )}
              />
            </Menu.Button>
          </div>
          <Transition
            as={Fragment}
            enter="transition ease-out duration-100"
            enterFrom="transform opacity-0 scale-95"
            enterTo="transform opacity-100 scale-100"
            leave="transition ease-in duration-75"
            leaveFrom="transform opacity-100 scale-100"
            leaveTo="transform opacity-0 scale-95"
          >
            <Menu.Items className="absolute right-0 z-10 mt-[4px] w-full origin-top-right rounded-[8px] border-[1px] border-[#ecedec] bg-white drop-shadow-[0px_2px_6px_rgba(0,0,0,0.18)]">
              {menuList.map((item, idx) => (
                <div key={idx} className="w-full">
                  <Menu.Item>
                    {({ active }) => (
                      <div
                        className={cls(
                          "cursor-pointer px-[24px] py-[18px] text-M3 font-normal text-black",
                          active ? "bg-gray-6" : "",
                          menuList.length - 1 === idx
                            ? ""
                            : "border-b-[1px] border-b-[#ecedec]",
                        )}
                        onClick={() => onClick(item.id)}
                      >
                        {item.name}
                      </div>
                    )}
                  </Menu.Item>
                </div>
              ))}
            </Menu.Items>
          </Transition>
        </>
      )}
    </Menu>
  );
}
